import { LanguageLabel } from '../enums/language-label.enum';
import { LanguageValue } from '../enums/language-value.enum';

export const AVAILABLE_LANGUAGES = [
  { label: LanguageLabel.ENGLISH, value: LanguageValue.ENGLISH },
  { label: LanguageLabel.GERMAN, value: LanguageValue.GERMAN },
  { label: LanguageLabel.POLISH, value: LanguageValue.POLISH },
  { label: LanguageLabel.POLISH_BDO, value: LanguageValue.POLISH_BDO },
];
